import React from 'react';
import { useNavigate } from 'react-router-dom';
import './HomePage.css';

const HomePage = () => {
  const navigate = useNavigate();

  const handleLoginClick = () => {
    navigate('/login');
  };

  const handleGetTruckClick = () => {
    navigate('/truck-search');
  };

  const handleContactSubmit = (e) => {
    e.preventDefault();
    // In a real app, this would send the form data to a backend
    alert('Thank you for your message! We will get back to you soon.');
    e.target.reset();
  };

  return (
    <div className="homepage">
      {/* Header */}
      <header className="homepage-header">
        <div className="header-container">
          <div className="logo-section">
            <div className="logo">
              <span className="logo-icon">🚚</span>
              <span className="logo-text">Nettaa Logistics</span>
            </div>
          </div>
          <nav className="header-nav">
            <a href="#" className="nav-link active">Home</a>
            <a href="#about" className="nav-link">About Us</a>
            <a href="#services" className="nav-link">Services</a>
            <a href="#contact" className="nav-link">Contact Us</a>
            <button className="btn-login" onClick={handleLoginClick}>
              Login
            </button>
          </nav>
        </div>
      </header>

      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-container">
          <div className="hero-content">
            <div className="hero-left">
              <div className="booking-card">
                <h3 className="booking-title">Need a full truck?</h3>
                <div className="booking-form">
                  <div className="input-group">
                    <span className="input-icon">📍</span>
                    <input
                      type="text"
                      placeholder="Enter your loading city"
                      className="city-input"
                    />
                  </div>
                  <div className="input-group">
                    <span className="input-icon">📍</span>
                    <input
                      type="text"
                      placeholder="Enter your unloading city"
                      className="city-input"
                    />
                  </div>
                  <div className="promo-banner">
                    <span className="promo-icon">🎁</span>
                    <span className="promo-text">
                      Get <strong>₹50,000</strong> Free Cash on App Sign Up
                    </span>
                  </div>
                  <button className="btn-estimate" onClick={handleGetTruckClick}>Get truck</button>
                </div>
              </div>
            </div>
            <div className="hero-right">
              <h1 className="hero-headline">India ka #1 Truck Booking App</h1>
              <p className="hero-subheadline">Trusted by 50,000+ Businesses Across India</p>
              <div className="trucks-visual">
                <div className="truck truck-1">🚚</div>
                <div className="truck truck-2">🚛</div>
                <div className="truck truck-3">🚛</div>
                <div className="truck truck-4">🚚</div>
                <div className="truck truck-5">🚛</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* App Download Section */}
      <section className="app-section">
        <div className="app-container">
          <div className="app-content">
            <div className="app-left">
              <h2 className="app-headline">Get ₹50,000 on Sign up!</h2>
              <p className="app-description">
                Enjoy seamless booking experience only on- Nettaa Truck Booking App.
              </p>
              <div className="qr-section">
                <div className="qr-code">📱</div>
                <p className="qr-text">Scan this QR</p>
              </div>
            </div>
            <div className="app-right">
              <p className="download-text">Download the app</p>
              <div className="app-badges">
                <button className="app-badge google-play">
                  <span>Get it on</span>
                  <strong>Google Play</strong>
                </button>
                <button className="app-badge app-store">
                  <span>Download on the</span>
                  <strong>App Store</strong>
                </button>
              </div>
              <div className="phone-mockup">
                <div className="phone-screen">
                  <p className="phone-text">BOOK TRUCKS IN 30 MINS</p>
                  <div className="phone-map">🗺️</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="why-choose-section">
        <div className="why-choose-container">
          <h2 className="section-title">Why Choose Us?</h2>
          <p className="section-subtitle">
            With 26+ lakh GPS-enabled trucks delivering top features for you.
          </p>
          <div className="comparison-table">
            <table className="features-table">
              <thead>
                <tr>
                  <th>Features</th>
                  <th>Nettaa</th>
                  <th>Others</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Book Trucks in 30 mins</td>
                  <td><span className="check">✓</span></td>
                  <td><span className="cross">✗</span></td>
                </tr>
                <tr>
                  <td>All Truck Types</td>
                  <td><span className="check">✓</span></td>
                  <td><span className="cross">✗</span></td>
                </tr>
                <tr>
                  <td>Deliver across India</td>
                  <td><span className="check">✓</span></td>
                  <td><span className="cross">✗</span></td>
                </tr>
                <tr>
                  <td>Market's Best Price</td>
                  <td><span className="check">✓</span></td>
                  <td><span className="cross">✗</span></td>
                </tr>
                <tr>
                  <td>24x7 GPS Tracking</td>
                  <td><span className="check">✓</span></td>
                  <td><span className="cross">✗</span></td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* More Features Section */}
      <section className="more-features-section">
        <div className="more-features-container">
          <h2 className="section-title">Additional Features</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon-large">📍</div>
              <p>Real-time GPS Tracking</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon-large">✅</div>
              <p>Verified & Trusted Drivers</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon-large">🎧</div>
              <p>24x7 Dedicated Support</p>
            </div>
          </div>
          <div className="cost-reduction-banner">
            <span className="banner-icon">💰</span>
            <p>
              With these smart features you can reduce logistics costs by <strong>12-20%</strong>.
            </p>
          </div>
        </div>
      </section>

      {/* About Us Section */}
      <section id="about" className="about-section">
        <div className="about-container">
          <h2 className="section-title">About Us</h2>
          <div className="about-content">
            <div className="about-text">
              <p className="about-description">
                <strong>Nettaa Logistics</strong> is India's leading truck booking platform, 
                revolutionizing the way businesses handle their freight transportation needs. 
                With a commitment to excellence and innovation, we connect businesses with 
                reliable truck owners and drivers across the country.
              </p>
              <p className="about-description">
                Our mission is to make truck booking as simple as booking a cab. We leverage 
                cutting-edge technology to provide real-time tracking, transparent pricing, 
                and seamless booking experiences. Trusted by over <strong>50,000+ businesses</strong>, 
                we have successfully facilitated millions of shipments across India.
              </p>
              <div className="about-stats">
                <div className="stat-item">
                  <div className="stat-number">50,000+</div>
                  <div className="stat-label">Happy Customers</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">26+ Lakh</div>
                  <div className="stat-label">GPS-Enabled Trucks</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">19,000+</div>
                  <div className="stat-label">PIN Codes Covered</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">24/7</div>
                  <div className="stat-label">Customer Support</div>
                </div>
              </div>
            </div>
            <div className="about-image">
              <div className="about-visual">🚚</div>
            </div>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="services-section">
        <div className="services-container">
          <h2 className="section-title">Our Services</h2>
          <p className="section-subtitle">
            Comprehensive logistics solutions tailored to meet your business needs
          </p>
          <div className="services-grid">
            <div className="service-card">
              <div className="service-icon">🚛</div>
              <h3 className="service-title">Full Truck Load (FTL)</h3>
              <p className="service-description">
                Book entire trucks for your cargo with guaranteed space and dedicated service. 
                Perfect for large shipments and bulk transportation needs.
              </p>
            </div>
            <div className="service-card">
              <div className="service-icon">📦</div>
              <h3 className="service-title">Part Load (PTL)</h3>
              <p className="service-description">
                Share truck space with other shipments and save costs. Ideal for smaller 
                consignments that don't require a full truck.
              </p>
            </div>
            <div className="service-card">
              <div className="service-icon">📍</div>
              <h3 className="service-title">Real-Time Tracking</h3>
              <p className="service-description">
                Monitor your shipment's location in real-time with our advanced GPS tracking 
                system. Get instant updates and peace of mind.
              </p>
            </div>
            <div className="service-card">
              <div className="service-icon">💰</div>
              <h3 className="service-title">Transparent Pricing</h3>
              <p className="service-description">
                Get the best market rates with complete price transparency. No hidden charges, 
                no surprises - just fair and competitive pricing.
              </p>
            </div>
            <div className="service-card">
              <div className="service-icon">✅</div>
              <h3 className="service-title">Verified Drivers</h3>
              <p className="service-description">
                All our drivers are verified, experienced, and background-checked. Your cargo 
                is in safe and professional hands.
              </p>
            </div>
            <div className="service-card">
              <div className="service-icon">🎧</div>
              <h3 className="service-title">24/7 Support</h3>
              <p className="service-description">
                Round-the-clock customer support to assist you with any queries or issues. 
                We're always here to help you.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Us Section */}
      <section id="contact" className="contact-section">
        <div className="contact-container">
          <h2 className="section-title">Contact Us</h2>
          <p className="section-subtitle">
            Get in touch with us for any queries, support, or business inquiries
          </p>
          <div className="contact-content">
            <div className="contact-info">
              <div className="contact-item">
                <div className="contact-icon">📍</div>
                <div className="contact-details">
                  <h3 className="contact-label">Office Address</h3>
                  <p className="contact-text">
                    123 Transport Street,<br />
                    Logistics City,<br />
                    India - 123456
                  </p>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">📞</div>
                <div className="contact-details">
                  <h3 className="contact-label">Phone</h3>
                  <p className="contact-text">
                    <a href="tel:+919876543210" className="contact-link">+91 9876543210</a><br />
                    <a href="tel:+919876543211" className="contact-link">+91 9876543211</a>
                  </p>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">✉️</div>
                <div className="contact-details">
                  <h3 className="contact-label">Email</h3>
                  <p className="contact-text">
                    <a href="mailto:info@nettaa.com" className="contact-link">info@nettaa.com</a><br />
                    <a href="mailto:support@nettaa.com" className="contact-link">support@nettaa.com</a>
                  </p>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon">🕒</div>
                <div className="contact-details">
                  <h3 className="contact-label">Business Hours</h3>
                  <p className="contact-text">
                    Monday - Saturday: 9:00 AM - 8:00 PM<br />
                    Sunday: 10:00 AM - 6:00 PM<br />
                    <strong>24/7 Support Available</strong>
                  </p>
                </div>
              </div>
            </div>
            <div className="contact-form-container">
              <h3 className="form-title">Send us a Message</h3>
              <form className="contact-form" onSubmit={handleContactSubmit}>
                <div className="form-group">
                  <input 
                    type="text" 
                    className="form-input" 
                    placeholder="Your Name" 
                    required 
                  />
                </div>
                <div className="form-group">
                  <input 
                    type="email" 
                    className="form-input" 
                    placeholder="Your Email" 
                    required 
                  />
                </div>
                <div className="form-group">
                  <input 
                    type="tel" 
                    className="form-input" 
                    placeholder="Your Phone Number" 
                    required 
                  />
                </div>
                <div className="form-group">
                  <select className="form-input" required>
                    <option value="">Select Subject</option>
                    <option value="booking">Booking Inquiry</option>
                    <option value="support">Customer Support</option>
                    <option value="partnership">Partnership</option>
                    <option value="other">Other</option>
                  </select>
                </div>
                <div className="form-group">
                  <textarea 
                    className="form-input form-textarea" 
                    placeholder="Your Message" 
                    rows="5"
                    required
                  ></textarea>
                </div>
                <button type="submit" className="btn-submit">
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="homepage-footer">
        <div className="footer-container">
          <div className="footer-left">
            <div className="footer-logo">
              <span className="logo-icon">🚚</span>
              <span className="logo-text">Nettaa Logistics</span>
            </div>
            <p className="footer-tagline">BOOK TRUCKS IN 30 MINS</p>
            <p className="footer-info">Serving more than 19,000 PIN Codes across India.</p>
            <div className="footer-address">
              <p>Office Address:</p>
              <p>123 Transport Street, Logistics City, India - 123456</p>
              <p>Contact: +91 9876543210</p>
            </div>
          </div>
          <div className="footer-middle">
            <h3 className="footer-heading">ACCOUNT</h3>
            <ul className="footer-links">
              <li><a href="#terms">Terms And Conditions</a></li>
              <li><a href="#privacy">Privacy Policy</a></li>
              <li><a href="#terms-bazaar">Terms & conditions for Bazaar</a></li>
              <li><a href="#privacy-bazaar">Privacy Policy for Bazaar</a></li>
              <li><a href="#terms-use">Terms Of Use</a></li>
              <li><a href="#cookie">Cookie Policy</a></li>
              <li><a href="#careers">Careers</a></li>
            </ul>
          </div>
          <div className="footer-right">
            <h3 className="footer-heading">SOCIALS</h3>
            <div className="social-links">
              <a href="#facebook" className="social-link">📘 Facebook</a>
              <a href="#linkedin" className="social-link">💼 LinkedIn</a>
              <a href="#youtube" className="social-link">📺 YouTube</a>
              <a href="#instagram" className="social-link">📷 Instagram</a>
            </div>
          </div>
        </div>
        <div className="footer-copyright">
          <p>© Copyright Nettaa Logistics | All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
};

export default HomePage;

